import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { SortIcon } from "components/common/Icons/SortIcon";
import { List } from "components/common/List/List";
import { Popup } from "components/common/Popup/Popup";
import { SmallContainer } from "components/common/SmallContainer/SmallContainer";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useSort } from "./useSort";
import { getSortListItems } from "components/modules/Editors/BulkResizer/BottomMenu/Content/Sort/Sort";

export const Sort = () => {
    const { isOpen, toggle, close, handleClick, sort: currentSort } = useSort();

    return (
        <Popup
            isOpen={isOpen}
            close={close}
            content={
                <div
                    className="absolute right-0 flex flex-col my-1 overflow-hidden bg-white border shadow-lg top-full dark:bg-darkSurface-200 rounded-xl border-irGray-400 dark:border-darkSurface-400"
                    data-testid="sort-list-container"
                >
                    <List callback={handleClick} items={getSortListItems(currentSort)} />
                </div>
            }
        >
            <ToolTip text={capitalize(translateFunc("filter"))}>
                <SmallContainer
                    className={`cursor-pointer flex items-center justify-center ${
                        isOpen
                            ? "bg-irGray-200 dark:bg-darkSurface-200"
                            : "bg-white dark:bg-darkSurface-300 dark:hover:bg-darkSurface-200"
                    } hover:bg-irGray-200 border border-irGray-400 dark:border-darkSurface-100 rounded-xl p-2.5`}
                    onClick={toggle}
                    data-testid="sort-container-opener"
                >
                    <SortIcon width={24} height={24} />
                </SmallContainer>
            </ToolTip>
        </Popup>
    );
};
